/* eslint
 wrap-iife: 1,
 global-require: 1,
 no-param-reassign: 1,
 guard-for-in: 1,
 no-restricted-syntax: 1,
 no-invalid-this: 1
 */
(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD
        define([
            'handlebars/handlebars'
        ], factory);
    } else if (typeof exports === 'object') {
        // Node, CommonJS-like
        module.exports = factory(
            require('handlebars/handlebars')
        );
    } else {
        // Browser globals (root is window)
        root.CustomHelpers = factory(
            root.Handlebars
        );
    }
})(this, function (Handlebars) {
    var ClientUtils = {
        registerHelpers: function (helpers) {
            for (var prop in helpers) {
                Handlebars.registerHelper(prop, helpers[prop]);
            }
        }
    };

    return ClientUtils;
});
